export class JigsawGame{
	constructor(pcs, canvas, askQuestion = undefined){
		this.askQuestion = askQuestion;
		this.rawPieces = pcs;
		this.canvas = canvas;
		this.ctx = canvas.getContext("2d");
		setTimeout(() => {
			this.Initalize();
		}, 1500);
	}

	Initalize(){
		//Load components
		this.holders = [];
		this.pieces = [];
		var outPos = {
			posit: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16".split(','),
			getPos(){
				var randPos = Math.floor(Math.random() * this.posit.length);
				var ret = this.posit[randPos];
				this.posit.splice(randPos, 1);
				return ret;
			}
		};
		this.rawPieces.forEach(el => {
			this.pieces.push(new PuzzlePiece(el.pos, el.data, outPos.getPos(), this.askQuestion));
			this.holders.push(new HolderPiece(el.pos));
		});

		//FPS Logic
		this.lastCalledTime = Date.now();
		this.fps = 0;
		this.fpsi = 0;

		this.canvas.onmousedown = (e) => {e.preventDefault();this.mouseEvent(e)};
		this.canvas.onmouseup = (e) => {e.preventDefault();this.mouseEvent(e)};
		this.canvas.onmousemove = (e) => {e.preventDefault();this.mouseEvent(e)};
		this.canvas.ontouchstart = (e) => {e.preventDefault();this.mouseEvent(e)};
		this.canvas.ontouchend = (e) => {e.preventDefault();this.mouseEvent(e)};
		this.canvas.ontouchmove = (e) => {e.preventDefault();this.mouseEvent(e)};

		this.correctPlacing = true;

		//Begin the loop
		this.update();
	}

	update(){
		this.ctx.clearRect(0,0,this.canvas.width, this.canvas.height);

		var delta = (Date.now() - this.lastCalledTime)/1000;
		this.DRAW(delta);
		this.lastCalledTime = Date.now();
		if(this.fpsi > 60){
			this.fpsi = 0;
			this.fps = 1/delta;
		}else{
			this.fpsi += 1;
		}
		this.ctx.fillStyle = "#00ff00";
		this.ctx.font = "15px Arial";
		this.ctx.textAlign = "left";
		// this.ctx.fillText(Math.round(this.fps) + " FPS", 0, 15);

		window.requestAnimationFrame(() => {this.update()});
	}

	resetPiece(i){
		this.pieces.forEach(el => {
			// console.log("RESETTING", el.boardPos, "==", i);
			if(el.boardPos == i){
				el.correctPositioning = false;
				el.isPlaced = false;
			}
		});
	}

	mouseEvent(e){
		
		var type = null;
		var x = 0;
		var y = 0;
		if(e.type == "touchstart"){
			type = "mousedown";
			x = e.touches[0].clientX;
			y = e.touches[0].clientY;
		}else if(e.type == "touchend"){
			type = "mouseup";
			x = e.changedTouches[0].clientX;
			y = e.changedTouches[0].clientY;
		}else if(e.type == "touchmove"){
			type = "mousemove";
			x = e.touches[0].clientX;
			y = e.touches[0].clientY;
		}else if(e.type == "mousedown"){
			type = "mousedown";
			x = e.clientX;
			y = e.clientY;
		}else if(e.type == "mouseup"){
			type = "mouseup";
			x = e.clientX;
			y = e.clientY;
		}else if(e.type == "mousemove"){
			type = "mousemove";
			x = e.clientX;
			y = e.clientY;
		}
		// console.log(e.type);
		this.pieces.forEach(el => {
			el.mouseEvent(type, x, y, this.canvas.getBoundingClientRect());
		});
		this.holders.forEach(el => {
			el.mouseEvent(type, x, y, this.canvas.getBoundingClientRect());
		});
	}

	DRAW(delta){
		// this.ctx.fillStyle = (this.correctPlacing) ? "#00ff00" : "#ff0000";
		// this.ctx.fillRect(250, 0, 500, 500);
		this.holders.forEach(el => {
			el.draw(this.ctx, delta);
		});
		this.pieces.forEach(el => {
			if(!el.mouseDat.state)
				el.draw(this.ctx, delta);
		});
		this.pieces.forEach(el => {
			if(el.mouseDat.state)
				el.draw(this.ctx, delta);
		});
		var isHoldingAPiece = false;
		var heldPos = null;
		var heldIndex = null;
		this.pieces.forEach((el,i) => {
			if(el.mouseDat.state){
				isHoldingAPiece = true;
				heldPos = el.boardPos;
				heldIndex = i;
			}
		});
		if(isHoldingAPiece){
			this.holders.forEach(el => {
				if(el.isMouseOver && el.boardPos == heldPos){
					this.correctPlacing = true;
					this.pieces[heldIndex].correctPositioning = true;
				}else if(el.isMouseOver){
					this.correctPlacing = false;
					this.pieces[heldIndex].correctPositioning = false;
				}
				el.isHoldingPiece = true;
			});
		}else{
			this.holders.forEach(el => {
				el.isHoldingPiece = false;
			});
		}
	}
}

class PuzzlePiece{
	constructor(pos, imgSrc, outPos, askQuestion = undefined){
		this.askQuestion = askQuestion;
		this.outPos = outPos;
		this.boardPos = pos;
		this.img = new Image();
		this.imgLoaded = false;
		this.img.onload = () => {
			this.imgLoaded = true;
			pos = pos.split('');
			this.x = 250 + (pos[1] * 125);
			this.y = (pos[0] * 125);

			//resize image for outer placing
			var ratio = Math.min(125 / this.img.width, 125 / this.img.height);
			this.outW = this.img.width * ratio;
			this.outH = this.img.height * ratio;
			if(this.outW < 125){
				this.outX += (125-this.outW)/2;
			}
			if(this.outH < 125){
				this.outY += (125-this.outH)/2;
			}

			switch(pos.join('')){
				case '02':
					this.x -= 40;
					break;
				case '10':
					this.y -= 40;
					break;
				case '11':
					this.x -= 40;
					break;
				case '12':
					this.y -= 40;
					break;
				case '13':
					this.x -= 40;
					this.y -= 40;
					break;
				case '21':
					this.y -= 40;
					break;
				case '22':
					this.x -= 40;
					break;
				case '30':
					this.y -= 40;
					break;
				case '31':
					this.x -= 40;
					break;
				case '32':
					this.x -= 40;
					this.y -= 40;
					break;
			}

		};
		var outInfo = this.getOutPos(outPos);
		this.outX = outInfo.x;
		this.outY = outInfo.y;
		this.outW = 125;
		this.outH = 125;
		this.img.src = imgSrc;
		this.isPlaced = false;
		this.mouseDat = {
			x: 0,
			y: 0,
			state: false
		};
		this.correctPositioning = false;


		function sound(src) {
			this.sound = document.createElement("audio");
			this.sound.src = src;
			this.sound.setAttribute("preload", "auto");
			this.sound.setAttribute("controls", "none");
			this.sound.style.display = "none";
			document.body.appendChild(this.sound);
				this.play = function(){
				this.sound.play();
			}
			this.stop = function(){
			this.sound.pause();
			}
		}
		this.click = new sound("/media/click.mp3");
	}

	getOutPos(pos){
		switch (pos) {
			case '1':return {x:0, y:0};
			case '2':return {x:125, y:0};
			case '3':return {x:0, y:125};
			case '4':return {x:125, y:125};
			case '5':return {x:0, y:250};
			case '6':return {x:125, y:250};
			case '7':return {x:0, y:375};
			case '8':return {x:125, y:375};
			case '9':return {x:750, y:0};
			case '10':return {x:875, y:0};
			case '11':return {x:750, y:125};
			case '12':return {x:875, y:125};
			case '13':return {x:750, y:250};
			case '14':return {x:875, y:250};
			case '15':return {x:750, y:375};
			case '16':return {x:875, y:375};
			default: return {x:500, y:250};
		}
	}

	mouseEvent(type, x, y, rect){
		if(this.isPlaced) return null;
		switch(type){
			case "mousemove":
				//mouse was moved update something
				this.mouseDat.x = x - rect.left;
				this.mouseDat.y = y - rect.top;
				break;
			case "mousedown":
				//User clicked somewhere, detect if this element was clicked
				this.mouseDat.x = x - rect.left;
				this.mouseDat.y = y - rect.top;
				if(this.mouseDat.x > this.outX && this.mouseDat.x <= this.outX + this.outW && this.mouseDat.y > this.outY && this.mouseDat.y <= this.outY + this.outH){
					this.mouseDat.state = true;
					this.click.play();
				}
				break;
			case "mouseup":
				//mouse was moved update something
				if(this.correctPositioning){
					this.isPlaced = true;
					if(this.askQuestion) this.askQuestion(this.boardPos);
					this.click.play();
				}
				this.mouseDat.state = false;
				//check if the thing was placed in the right spot, if yes then voila otherwise >_>
				break;
		}
	}

	draw(ctx, delta){
		if(!this.imgLoaded) return null;
		//draw the thing here
		if(this.isPlaced){
			ctx.drawImage(this.img, this.x, this.y); //this line places the item on its original place
		}else{
			if(this.mouseDat.state){
				//Move mouse
				ctx.drawImage(this.img, this.mouseDat.x - (this.img.width/2), this.mouseDat.y - (this.img.height/2));
			}else{
				ctx.drawImage(this.img, this.outX, this.outY, this.outW, this.outH);
			}
		}
	}
}

class HolderPiece{
	constructor(pos){
		this.boardPos = pos;
		pos = pos.split('');
		this.x = 250 + (pos[1] * 125);
		this.y = (pos[0] * 125);
		// this.img.src = imgSrc;
		this.mouseDat = {
			x: 0,
			y: 0,
			state: false
		};
		this.fillImage = false;
		this.isHoldingPiece = false;
		this.isMouseOver = false;
	}

	mouseEvent(type, x, y, rect){
		switch(type){
			case "mousemove":
				//mouse was moved update something
				this.mouseDat.x = x - rect.left;
				this.mouseDat.y = y - rect.top;
				if(this.mouseDat.x > this.x && this.mouseDat.x <= this.x + 125 && this.mouseDat.y > this.y && this.mouseDat.y <= this.y + 125){
					if(this.isHoldingPiece) this.fillImage = true;
					else this.fillImage = false;
					this.isMouseOver = true;
				}else{
					this.fillImage = false;
					this.isMouseOver = false;
				}
				break;
			case "mousedown":
				//User clicked somewhere, detect if this element was clicked
				break;
			case "mouseup":
				this.fillImage = false;
				
				//mouse was moved update something
				// this.mouseDat.state = false;
				//check if the thing was placed in the right spot, if yes then voila otherwise >_>
				break;
		}
	}

	draw(ctx, delta){
		//draw the thing here
		if(!this.fillImage){
			ctx.filter = "opacity(0%)";
		}else{
			ctx.filter = "opacity(100%)";
		}
		// ctx.drawImage(this.img, this.x, this.y);
		ctx.fillStyle = "#00FFEA99";
		ctx.fillRect(this.x, this.y, 125, 125);
		if(!this.fillImage){
			ctx.filter = "none";
		}
	}
}